const actionTypes = {
    SET_SELECTORIMAGE_STATE: "SET_SELECTORIMAGE_STATE"
};

export const setSelectorImageState = (selectorimage, state) => {
    return {type: actionTypes.SET_SELECTORIMAGE_STATE, selectorimage, state}
}

export default actionTypes;